import { createBrowserHistory } from 'history';

const history = createBrowserHistory();
// singleton
export default history;
